import { render, staticRenderFns } from "./accout.vue?vue&type=template&id=24ff91cf&scoped=true&"
import script from "./accout.vue?vue&type=script&lang=js&"
export * from "./accout.vue?vue&type=script&lang=js&"
import style0 from "./accout.vue?vue&type=style&index=0&id=24ff91cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ff91cf",
  null
  
)

export default component.exports